import { EmailServiceOptions } from './email-service';
import { Geography, MarketplaceProvider, Tenant } from './tenant';

export enum PushNotificationType {
    NEGOTIATION_VALIDATION_REQUIRED = 'NEGOTIATION_VALIDATION_REQUIRED',
    NEGOTIATION_HUMAN_REQUIRED = 'NEGOTIATION_HUMAN_REQUIRED',
    NEGOTIATION_EMAIL_RECEIVED = 'NEGOTIATION_EMAIL_RECEIVED',
    BOOKING_TIMING_REVIEW = 'BOOKING_TIMING_REVIEW',
    BOOKING_CREATED = 'BOOKING_CREATED',
    TRUCK_OFF_COURSE = 'TRUCK_OFF_COURSE',
    AUTO_SEARCH_COMPLETED = 'AUTO_SEARCH_COMPLETED',
    AUTO_SEARCH_ERRORED = 'AUTO_SEARCH_ERRORED',
    OFFER_DETECTED = 'OFFER_DETECTED',
    GENERAL = 'GENERAL',
    BOOKING_UNREACHABLE = 'BOOKING_UNREACHABLE'
}

export const enum UserPlatformRole {
    CUSTOMER = 0,
    ADMIN = 3
}
export const enum UserPlatformSubRole {
    DIRECTOR = 1,
    TRUCK_MANAGER = 2,
    TRUCK_DRIVER = 3,
    REVIEWER = 4,
    NONE = 5
}

export enum I18nLang {
    EN = 0,
    FR = 1,
    DE = 2,
    IT = 3,
    ES = 4,
    NL = 5,
    PL = 6,
    PT = 7,
}

export interface User extends EmailServiceOptions {
    id?: number;
    updatedOn: Date;
    userId: string;
    role: UserPlatformRole;
    lastLogin: Date;
    lastUseApproximation: Date;
    loginCount: number;
    accountName: string;
    passwordHash: string;
    salt: string;
    resetKey: string;
    iatNotBefore: Date;
    lockedAt: Date;
    name: string;
    confirmedAt: Date;
    lastConnectIp: string;
    subRole: UserPlatformSubRole;
    notificationsOptOuts: string;
    notificationTypesOptOuts: PushNotificationType[];
    notificationSilentTypes?: PushNotificationType[];
    platformEndpointArn: string;
    imageUrl: string;
    preferences: string;
    tenant_id: number;
    preferredPosition: Geography;
    preferredRadius: number;
    preferredCountry: string;
    language: I18nLang;
    tenantOverrides?: Partial<Tenant>;
    server: ServerInfo;
}

export interface ServerInfo {
    testMode: boolean;
    vapidPublicKey: string;
    subscriptionsEnabled: boolean;
    marketPlacesWithoutNegotiate: MarketplaceProvider[];
}